import { Page } from "./types";

export const initialPage: Page = {
  id: -1,
  title: "",
  metaDescription: "",
  metaTitle: "",
  slug: "",
  image: null,
  descriptionText: "",
  createdAt: new Date(),
  updatedAt: new Date(),
};
